// Local translations
export const T = {
  en_GB: {
    editCostType: "Edit Cost Type",
    addCostType: "Add Cost Type",
    editDescription: "Update the cost type name and mapped API keys.",
    createDescription: "Create a new cost type with prioritized API key mappings.",
    name: "Name",
    namePlaceholder: "e.g., Ongoing Charges",
    nameRequired: "Name is required",
    category: "Category",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryWithdrawal: "Withdrawal",
    categoryDescription:
      "Recurring costs are charged annually. Deposit/Withdrawal costs are one-time.",
    apiKeyMappings: "API Key Mappings",
    apiKeyDescription:
      "Select the API fields to map to this cost type. Click the number to increase priority.",
    selectAtLeastOneKey: "Select at least one API key",
    cancel: "Cancel",
    save: "Save",
    failedToSave: "Failed to save cost type",
  },
  nb_NO: {
    editCostType: "Rediger kostnadstype",
    addCostType: "Legg til kostnadstype",
    editDescription: "Oppdater navnet på kostnadstypen og tilknyttede API-nøkler.",
    createDescription: "Opprett en ny kostnadstype med prioriterte API-nøkkelkoblinger.",
    name: "Navn",
    namePlaceholder: "f.eks. Løpende kostnader",
    nameRequired: "Navn er påkrevd",
    category: "Kategori",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryWithdrawal: "Uttak",
    categoryDescription:
      "Løpende kostnader belastes årlig. Innskudd/Uttak-kostnader er engangsbeløp.",
    apiKeyMappings: "API-nøkkelkoblinger",
    apiKeyDescription:
      "Velg API-feltene som skal kobles til denne kostnadstypen. Klikk på nummeret for å øke prioritet.",
    selectAtLeastOneKey: "Velg minst én API-nøkkel",
    cancel: "Avbryt",
    save: "Lagre",
    failedToSave: "Kunne ikke lagre kostnadstype",
  },
} as const;
